<template>
  <v-container app :fluid="true" class="pt-0">
    <v-row>
      <v-col cols="3">
        <v-autocomplete
          :items="customers"
          dense
          solo
          clearable
          clear-icon="far fa-times-circle"
          label="Clientes"
          persistent-hint
          :item-text="customText"
          item-value="id"
          hide-details
          @change="handleSelecteCustomer"
          :filter="customFilter"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title v-if="data.item.type_document === 'DNI'"
                >{{ data.item.name }} {{ data.item.surname }}</v-list-item-title
              >
              <v-list-item-title v-else>{{ data.item.name }}</v-list-item-title>
              <v-list-item-subtitle
                >{{ data.item.type_document }}:
                {{ data.item.document }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="2">
        <v-menu
          v-model="menuFromDate"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="from_date"
              label="Desde"
              readonly
              solo
              dense
              clearable
              v-on="on"
              @click:clear="handleClearFrom"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="from_date"
            @input="menuFromDate = false"
            no-title
            locale="es"
            @change="handleChangeFormDate"
          >
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="2">
        <v-menu
          v-model="menuUntilDate"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="until_date"
              label="Hasta"
              readonly
              solo
              dense
              clearable
              v-on="on"
              @click:clear="handleClearUntil"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="until_date"
            @input="menuUntilDate = false"
            no-title
            @change="handleChangeUntilDate"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="2">
        <v-btn
          dark
          color="green"
          @click="handleExportExcel"
          v-if="verifyPermission('exportar_reporte_ventas')"
        >
          XLS
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <template>
            <v-row>
              <v-col cols="12" class="pt-0">
                <v-data-table
                  class="wost-table"
                  :headers="headers"
                  :items="sales"
                  item-key="id"
                  height="65vh"
                  show-expand
                  :single-expand="true"
                  fixed-header
                >
                  <!-- <template v-slot:item.id="{ item }">
                    {{ item.id | (number - order) }}
                  </template> -->

                  <template v-slot:item.serie="{ item }">
                    <span v-if="item.serie">
                      {{ item.serie }}-{{ item.correlative }}
                    </span>
                  </template>

                  <template v-slot:item.customer_id="{ item }">
                    <span v-if="item.customer.type == 'Natural'">
                      {{ item.customer.name }} {{ item.customer.surname }}
                    </span>
                    <span v-else>
                      {{ item.customer.name }}
                    </span>
                    <span
                      :class="
                        'ml-3 sales-type-customer sales-type-' +
                          item.customer.type_document.toLowerCase()
                      "
                    >
                      {{ item.customer.type }}
                    </span>
                  </template>

                  <template v-slot:item.entry_time="{ item }">
                    {{ item.entry_time | moment("DD/MM/YYYY") }}
                  </template>

                  <template v-slot:item.delivery_time="{ item }">
                    {{ item.delivery_time | moment("DD/MM/YYYY") }}
                  </template>

                  <template v-slot:item.delivery_hour="{ item }">
                    {{ item.delivery_time | moment("hh:mm a") }}
                  </template>

                  <template v-slot:item.total="{ item }">
                    {{ item.total | currency("S/") }}
                  </template>

                  <template v-slot:expanded-item="{ item, headers }">
                    <td :colspan="headers.length" class="wost-td-expanded">
                      <sales-detail
                        :order="item"
                        :products="item.detail"
                      ></sales-detail>
                    </td>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div style="display: flex;">
                      <span v-if="item.canceled == 1" class="sale-canceled">
                        ANULADO
                      </span>
                      <v-icon
                        v-if="item.canceled == 0"
                        size="18"
                        color="error"
                        @click="handleViewCancelInvoice(item)"
                      >
                        far fa-times-circle
                      </v-icon>

                      <v-icon
                        v-if="item.type_document && item.canceled == 0"
                        class="ml-2"
                        size="18"
                        color="blue"
                        @click="handlePrintVoucher(item)"
                      >
                        fas fa-print
                      </v-icon>
                      <div>
                        <v-icon
                          v-if="item.link_pdf && item.customer.phone"
                          class="ml-2"
                          size="20"
                          color="green"
                          @click="handlePrintVoucherByWhatsapp(item)"
                        >
                          fab fa-whatsapp
                        </v-icon>
                        <v-icon
                          v-else-if="
                            item.link_pdf && item.customer.phone == null
                          "
                          class="ml-2"
                          size="20"
                          color="gray"
                          @click="handlePrintVoucherByWhatsapp(item)"
                        >
                          fab fa-whatsapp
                        </v-icon>
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" width="450" transition="fab-transition">
      <v-card v-if="sale" class="pl-0 pr-0">
        <v-card-title>
          <span class="subtitle-2 font-weight-bold">
            ANULACIÓN DE FACTURA
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-switch
                  v-model="form.generate_credit_note"
                  class="mt-0"
                  label="Generar Nota De Crédito"
                  :readonly="readonly_credit_note"
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>

            <!-- <v-row dense v-if="form.generate_credit_note">
              <v-col v-for="item in vouchers" :key="item.id" cols="12" md="4">
                <v-card
                  style="font-size: 9px !important;"
                  elevation="3"
                  link
                  :class="serie == item.correlative ? 'selected-card' : ''"
                  @click="handleChangeClickTypeVoucher(item)"
                >
                  <div
                    style="padding: 0px 15px; font-size: 14px ; color: black; font-weight: 700;"
                  >
                    <div style=" font-size: 10px; font-weight: 500;">
                      {{ item.type }}
                    </div>
                    <div>
                      <span style="">{{ item.correlative }}</span>
                    </div>
                    <div>
                      <span style="">{{ item.current_number }}</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row> -->

            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="sale.serie"
                  label="Serie"
                  outlined
                  hide-details
                  readonly
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="sale.correlative"
                  label="Número"
                  outlined
                  hide-details
                  readonly
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-textarea
                  ref="reason"
                  v-model="form.reason"
                  label="Motivo de anulación"
                  outlined
                  :rules="[
                    () => !!form.reason || 'Es necesario ingresar el motivo',
                  ]"
                  required
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container class="pt-0 pb-0">
            <v-row>
              <v-col cols="6">
                <v-btn dark color="red" block @click="handleCancel">
                  Cancelar
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn dark color="green" block @click="handleCancelInvoice">
                  Aceptar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import XLSX from "xlsx";

import { mapActions, mapMutations, mapState } from "vuex";

import SalesDetail from "../../components/Reports/SalesDetail";
import Tools from "../../helpers/Tools";
import TicketTools from "../../helpers/TicketTools";
import ApiReports from "../../apis/Reports";
// var worker = html2pdf();

import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "Sales",
  components: {
    SalesDetail,
  },
  data() {
    return {
      headers: [
        {
          text: "",
          value: "data-table-expand",
          width: 10,
          class: "header-table-expand",
        },
        {
          text: "COMPROBANTE",
          value: "type_document",
          align: "left",
          sortable: false,
          class: "header-table",
        },
        {
          text: "NRO. COMPROBANTE",
          value: "serie",
          align: "left",
          sortable: false,
          class: "header-table",
        },
        {
          text: "Cliente",
          value: "customer_id",
          align: "left",
          sortable: false,
          class: "header-table",
        },
        {
          text: "Fecha",
          value: "entry_time",
          align: "left",
          sortable: false,
          class: "header-table",
        },
        {
          text: "F. Entrega",
          value: "delivery_time",
          sortable: false,
          class: "header-table",
        },
        {
          text: "H. Entrega",
          value: "delivery_hour",
          sortable: false,
          class: "header-table",
        },
        {
          text: "Total",
          value: "total",
          sortable: false,
          class: "header-table",
        },
        {
          text: "",
          value: "action",
          class: "header-table-expand",
          align: "end",
          sortable: false,
        },
      ],
      sales: [],
      menuFromDate: false,
      from_date: null,
      menuUntilDate: false,
      until_date: null,
      customer_id: null,
      value_customer: "",
      final_deliveryman: null,
      dialog: false,
      sale: {},
      form: {
        sale_id: null,
        reason: null,
        generate_credit_note: false,
      },
      type_document: null,
      types_documents: ["BOLETA", "FACTURA", "TICKET"],
      readonly_credit_note: false,
      serie: "-",
    };
  },
  computed: {
    ...mapState("authentication", ["companyData"]),
    ...mapState("orders", ["customers", "deliveryUsers"]),
    ...mapState("voucher", ["vouchers"]),
  },
  methods: {
    ...mapActions("orders", ["getCustomers", "getDeliveryUsers"]),
    ...mapActions("reports", ["storeCreditNote"]),
    ...mapActions("voucher", ["getVouchers"]),
    getSales() {
      let params = {
        from: this.from_date,
        until: this.until_date,
        customer_id: this.customer_id,
        final_deliveryman: this.final_deliveryman,
      };
      ApiReports.sales(params).then(({ data }) => {
        this.sales = data;
      });
    },
    handleClearFrom() {
      this.from_date = null;
      this.getSales();
    },
    handleClearUntil() {
      this.until_date = null;
      this.getSales();
    },
    handleChangeFormDate() {
      this.getSales();
    },
    handleChangeUntilDate() {
      this.getSales();
    },
    customText(item) {
      let text = item.name;
      if (item.type_document === "DNI") {
        text = item.name + " " + item.surname;
      }
      return text;
    },
    customFilter(item, queryText, itemText) {
      let textName = "";
      if (item.name) {
        textName = item.name.toLowerCase();
      }

      let textDocument = "";
      if (item.document) {
        textDocument = item.document.toLowerCase();
      }

      let searchText = queryText.toLowerCase();

      return (
        textName.indexOf(searchText) > -1 ||
        textDocument.indexOf(searchText) > -1
      );
    },
    handleSelecteCustomer(value) {
      this.customer_id = null;
      if (value !== undefined && value !== null) {
        this.customer_id = value;
      }
      this.getSales();
    },
    handleExportExcel() {
      let data = XLSX.utils.json_to_sheet(this.prepareDataExport(this.sales), {
        header: [
          "type_document",
          "number_document",
          "customer",
          "type",
          "customer_document",
          "entry_time",
          "delivery_time",
          "delivery_hour",
          "total",
        ],
      });
      data["A1"].v = "Comprobante";
      data["B1"].v = "Nro. Comprobante";
      data["C1"].v = "Cliente";
      data["D1"].v = "Tipo";
      data["E1"].v = "RUC / DNI";
      data["F1"].v = "Fecha";
      data["G1"].v = "Fecha de Entrega";
      data["H1"].v = "Hora de Entrega";
      data["I1"].v = "Total";
      const workbook = XLSX.utils.book_new();
      const filename = "reporte-de-ventas";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    prepareDataExport(sales) {
      let dataExport = [];
      sales.forEach((element) => {
        let name = element.customer.name;
        if (element.customer.type == "Natural") {
          name = element.customer.name + " " + element.customer.surname;
        }

        let delivery_man = "";
        if (element.deliverystart) {
          delivery_man =
            element.deliverystart.first_name +
            " " +
            element.deliverystart.last_name;
        }

        let final_deliveryman = "";
        if (element.deliveryend) {
          final_deliveryman =
            element.deliveryend.first_name +
            " " +
            element.deliveryend.last_name;
        }

        let delivery_time = "";
        let delivery_hour = "";
        if (element.delivery_time) {
          delivery_time = Tools.setFormatDate(new Date(element.delivery_time));
          let dateDeliveryTime = new Date(element.delivery_time);
          delivery_hour =
            dateDeliveryTime.getHours() + ":" + dateDeliveryTime.getMinutes();
        }

        let number_document = "";
        if (element.serie) {
          number_document = element.serie + "-" + element.correlative;
        }

        let customer_document = "";
        if (element.customer) {
          customer_document = element.customer.document;
        }

        let itemData = {
          type_document: element.type_document,
          number_document: number_document,
          customer: name,
          type: element.customer.type,
          customer_document: customer_document,
          entry_time: Tools.setFormatDate(new Date(element.entry_time)),
          delivery_time: delivery_time,
          delivery_hour: delivery_hour,
          total: element.total,
        };
        dataExport.push(itemData);
      });
      return dataExport;
    },
    verifyPermission(permission) {
      return this.$hasPermision(permission);
    },
    handleViewCancelInvoice(sale) {
      this.clearForm();
      this.sale = sale;
      this.form.sale_id = this.sale.id;
      this.readOnlyCreditNote(sale);
      this.dialog = !this.dialog;
    },
    async handleCancelInvoice() {
      if (!this.existErrors()) {
        let creditNote = {
          order_id: this.form.sale_id,
          reason: this.form.reason,
          generate_credit_note: this.form.generate_credit_note,
        };
        await this.storeCreditNote(creditNote).catch((error) => {
          let response = error.request.response;
          let parseResponse = JSON.parse(response);
          this.$notify({
            group: "foo",
            type: "error",
            title: "RESULTADO DE PAGO",
            text: parseResponse.message,
          });
        });
        this.closeForm();
        this.getSales();
      }
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.form[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
    clearForm() {
      this.form.sale_id = null;
      this.form.reason = null;
      this.form.generate_credit_note = false;
      this.clearErrors();
    },
    closeForm() {
      this.clearForm();
      this.dialog = false;
    },
    handleCancel() {
      this.closeForm();
    },
    readOnlyCreditNote(sale) {
      console.log(sale);
      if (sale.type_document == null || sale.type_document == "") {
        this.readonly_credit_note = true;
      } else if (sale.type_document == "TICKET") {
        this.readonly_credit_note = true;
      } else if (
        sale.type_document == "BOLETA" ||
        sale.type_document == "FACTURA"
      ) {
        if (sale.send_fe == 0) {
          this.readonly_credit_note = true;
        }
      }
    },
    async handlePrintVoucher(order) {
      let content = await TicketTools.generateVoucherSale(
        order,
        this.companyData
      );
      this.printVoucher(content);
    },
    async handlePrintVoucherByWhatsapp(order) {
      // console.log(order);
      if (order.customer.phone) {
        const url = `
        https://web.whatsapp.com/send?phone=${order.customer.phone}&text=Estimado%20cliente%2C%0ASe%20env%C3%ADa%20la%20BOLETA%20DE%20VENTA%20ELECTR%C3%93NICA%20BA01-2738.%20Para%20ver%20click%20en%20el%20siguiente%20enlace%3A%0A%0A${order.link_pdf}`;
        window.open(url);
      }
      // console.log(order.link_pdf);
      // let content = await TicketTools.generateVoucherSale(
      //   order,
      //   this.companyData
      // );

      // const options = {
      //   margin: 10,
      //   filename: "voucher.pdf",
      //   image: { type: "jpeg", quality: 0.98 },
      //   html2canvas: { scale: 2 },
      //   jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      // };

      // Convertir el elemento HTML a PDF

      //   this.printVoucher(content);
    },
    printVoucher(content) {
      $("<iframe>", { name: "voucheriframe", class: "printFrame" })
        .appendTo("body")
        .contents()
        .find("body")
        .append(content);

      window.frames["voucheriframe"].focus();

      setTimeout(() => {
        window.frames["voucheriframe"].print();
      }, 500);

      setTimeout(() => {
        $(".printFrame").remove();
      }, 1000);
    },
    handleChangeClickTypeVoucher(voucher) {
      this.serie = voucher.correlative;
    },
  },
  mounted() {
    this.getSales();
    this.getVouchers({ type: "NOTA DE CREDITO" });
  },
};
</script>

<style scoped>
.sales-type-customer {
  display: inline-block;
  width: 80px;
  text-align: center;
  border-radius: 4px;
  font-size: 12px;
}

.sales-type-ruc {
  border: 1px solid #ff6424;
  color: #ff6424;
}

.sales-type-dni {
  border: 1px solid #1f308c;
  color: #1f308c;
}

.sale-canceled {
  color: #f44336;
  font-weight: bold;
}
</style>
